import { Col, Row } from 'antd';
import ListItem from 'Components/common/components/ListItem';
import React from 'react';
import styled from 'styled-components';
import {
  primaryFont, wMedium, retina, maxWidth, maxTablet, primaryHeadingColor,
  primaryColor, wMBold, maxMobile,
} from 'Utils/utilsStyle';
import { CheckCircleFilled } from '@ant-design/icons';
import { InsightDatum } from 'Types/PersonTypes';
import HTMLReactParser from 'html-react-parser';

const PersonalityParagraph = styled.p`
  font-family: ${primaryFont};
  font-size: 16px;
  font-weight: ${wMedium};
  line-height: 22px;
  letter-spacing: -0.33px;
  color: #424B50;
  margin: 0px;
  padding: 0px 0px 0px 5px;
  margin-bottom: 24px;
  white-space: pre-wrap;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 13px;
      line-height:18px;
      margin-bottom: 16px;
    }
  &.main-dec {
    font-family: ${primaryFont};
    font-style: normal;
    font-weight: ${wMedium};
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 24px;
    padding-left: 3px;
    color: #424B50;
    @media all and (max-width: ${maxWidth}) , ${retina} {
     font-size: 16px;
    }
  }
`;

const PersonalityHeading = styled.h3`
  font-family: ${primaryFont};
  font-size: 20px;
  font-weight: ${wMedium};
  line-height:24px;
  letter-spacing: -0.55px;
  color: ${primaryHeadingColor};
  margin: 8px 0px 8px 0px;
  padding-left: 5px;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    font-size: 17px;
    line-height:19px;
  }
  @media all and (max-width: ${maxTablet}) {
    margin-top: 16px;
  }
`;

const Wrapper = styled.div`
  padding: 0px 40px;
  @media all and (max-width: ${maxTablet}) {
    padding: 0px;
  }
  .list-data {
    margin-left: 6px;
  }
`;

const PersonalityHeadingMobile = styled.h3`
  font-family: ${primaryFont};
  font-size: 20px;
  font-weight: ${wMBold};
  line-height:24px;
  letter-spacing: -0.55px;
  color: ${primaryColor};
  margin: 0 0px 14px 0px;
  padding-left: 5px;
  display: none;
  @media all and (max-width: ${maxMobile}) {
    display: block;
    font-size: 18px;
    margin: 0 0px 5px 0px;
  }
`;

type Props = {
  topicHeading?: string,
  topicDescription?: string,
  tipsHeading?: string,
  tipsItemTitleArray?: string[],
  tipsItemColor?: string,
  insightData?: InsightDatum[],
} | typeof defaultProps;

const defaultProps = {
  topicHeading: '',
  topicDescription: '',
  tipsHeading: 'Tips:',
  tipsItemTitleArray: [],
  tipsItemColor: '#E79540',
  insightData: [],
};

const SliderContent = function SliderContent(props: Props) {
  const {
    topicDescription, tipsItemColor, insightData, topicHeading,
  } = props;
  const responsiveGrids = insightData?.length === 2 ? 12 : 8;
  return (
    <Wrapper className="slider-content-area">
      <PersonalityHeadingMobile>
        {topicHeading}
      </PersonalityHeadingMobile>
      <PersonalityParagraph className="main-dec">
        {topicDescription}
      </PersonalityParagraph>
      <Row gutter={16}>
        {insightData?.map((data) => (
          data?.tips?.length ? (
            <Col span={responsiveGrids} xs={24} sm={24} md={responsiveGrids} lg={responsiveGrids}>
              <PersonalityHeading>
                {data?.title}
              </PersonalityHeading>
              {data?.tips?.map((item) => (
                <ListItem
                  className="list-data"
                  title={item}
                  icon={(
                    <CheckCircleFilled
                      style={{ color: tipsItemColor }}
                    />
                  )}
                />
              ))}
            </Col>
          )
            : (
              <Col span={12} xs={24} sm={24} md={12}>
                <PersonalityHeading>
                  {data?.title}
                </PersonalityHeading>
                <PersonalityParagraph>
                  {HTMLReactParser(data?.description)}
                </PersonalityParagraph>
              </Col>
            )
        ))}
      </Row>
    </Wrapper>
  );
};

SliderContent.defaultProps = defaultProps;
export default SliderContent;
